export const activateReviewersMutation = `mutation activateReviewers($input: ActivateReviewersInput) {
    activateReviewers(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`;